export default "__VITE_ASSET__C1_qwwL3__"